<template>
  <div>
    <v-navigation-drawer
    v-model="sidebar" 
    app
    disable-resize-watcher
    dark>
      <v-list>
        <v-list-item>
          <v-list-item-content>Gooday</v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click.stop="sidebar =!sidebar">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            {{ $t('menuItems.HOME') }}
          </v-list-item-content>
        </v-list-item>
        <v-list v-if="!authed">
          <v-list-item 
          v-for="(item,index) in outMenuItems"
          :key="index"
          :to="{ name: item.link }"
          exact>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>{{ item.title }}</v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-else>
          <v-list-item 
          v-for="(item,index) in inMenuItems"
          :key="index"
          :to="{ name: item.link }"
          exact>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>{{ item.title }}</v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list-item v-if="authed" @click="signOut">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content :class="{amharic: am}">
            {{ $t('menuItems.SIGNOUT') }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
        app
        color="purple accent-3"
        
      >
        <span class="hidden-md-and-up">
          <v-app-bar-nav-icon x-large @click="sidebar = !sidebar"></v-app-bar-nav-icon>
        </span>
        <div class="d-flex align-left">
          <v-img
            alt="Gooday Logo"
            class="shrink mt-1"
            contain
            src="../assets/gooday-simplewhitelogo.png"
            transition="scale-transition"
            width="100"
          />
        </div>      
        <v-spacer></v-spacer>

        <v-btn :class="{amharic: am}" class="ma-1 hidden-sm-and-down" to="/">
          <v-icon left>mdi-home</v-icon> {{ $t('menuItems.HOME') }}
        </v-btn>
        <v-btn v-if="authed" :class="{amharic: am}" class="ma-1 hidden-sm-and-down" to="/feed">
          <v-icon left>mdi-briefcase-search</v-icon> {{ $t('menuItems.MYGOODAY') }}
        </v-btn>
        <v-btn v-if="!authed" :class="{amharic: am}" class="ma-1 hidden-sm-and-down"  to="/signin">
          <v-icon left>mdi-login</v-icon> {{ $t('menuItems.SIGNIN') }}
        </v-btn>
        <v-btn v-if="!authed" :class="{amharic: am}" class="ma-1 hidden-sm-and-down"  to="/signup">
          <v-icon left>mdi-account-plus</v-icon> {{ $t('menuItems.SIGNUP') }}
        </v-btn>
        <v-btn v-if="authed" :class="{amharic: am}" class="ma-1 hidden-sm-and-down" @click="signOut" to="/">
          <v-icon left>mdi-logout</v-icon> {{ $t('menuItems.SIGNOUT') }}
        </v-btn>
        <v-btn v-if="authed" :class="{amharic: am}" class="ma-1 hidden-sm-and-down" to="/myaccount">
          <v-icon left>mdi-settings</v-icon> {{ $t('menuItems.SETTINGS') }}
        </v-btn>
        <v-menu
          offset-y
          content-class="dropdown-menu">
          <template v-slot:activator="{ on }">
            <v-btn 
            :class="{amharic: am}"
            slot="activator"
            text v-on="on">
            <v-icon > mdi-earth </v-icon>
              &nbsp;{{ displayLocale }}
            </v-btn>
          </template>
          <v-list color="#212121">
            <v-list-item
              active-class="white--text"
              v-for="language in languages" :key="language.language" @click="changeLocale(language.language)">
              <countryFlag :country="language.flag" size="small" class="pl-5" />
              <v-list-item-title :class="{amharic: am}" class="ml-3" style="color:#FFFFFF;">{{ language.title.toUpperCase() }}</v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
    </v-app-bar>
  </div> 
</template>
<script>
import countryFlag from 'vue-country-flag';

export default {
    components: {
        countryFlag,
    },
    computed: {
      am() {
      // eslint-disable-next-line no-console
      // console.log("locale is :", this.$i18n.locale)
      return this.$i18n.locale === 'አማ' ? true : false 
      
     },
      displayLocale() {
            return this.$i18n.locale
      },
      languages() {
        return this.$store.getters['language/getLanguages']
      },
      authed() {
        return this.$store.getters['auth/isAuthenticated']
        // eslint-disable-next-line no-console
        // console.log("auth check : ", firebase.auth().currentUser)
        // return firebase.auth().currentUser ? true : false
      },
      outMenuItems() {
        return [
          {
            title: this.$t('menuItems.SIGNIN'),
            link: 'signin',
            icon: 'mdi-login'
          },
          {
            title: this.$t('menuItems.SIGNUP'),
            link: 'signup',
            icon: 'mdi-account-plus'
          },
        ]
      },
      inMenuItems() {
        return [
          {
            title: this.$t('menuItems.MYGOODAY'),
            link: 'feed',
            icon: 'mdi-briefcase-search',
          },
          {
            title: this.$t('menuItems.SETTINGS'),
            link: 'settings',
            icon: 'mdi-settings'
          }
        ]
      }
    },
    methods: {
        test() {},
        changeLocale(locale) {
          this.$i18n.locale = locale
        },
        signOut() {
          this.$store.dispatch('auth/signOut')  
        },
    },
    data: () => { 
      return {
        sidebar: false,
      }
    },
}
</script>
